<template>
	<section class="markets-hero-banner w-full">
		<div
			v-if="!news_list || news_list.length == 0"
			class="flex lg:grid lg:grid-cols-3 gap-4 lg:-mb-4 scrollbar-hide w-full"
		>
			<div
				class="col-span-2 rounded-xl shrink-0 w-[342px] lg:w-auto h-[342px] lg:h-[466px] animate-pulse"
				:class="{
					'bg-blue-300/[0.075]': alternative,
					'bg-slate-300/[0.1]': !alternative
				}"
			/>

			<div class="flex gap-4 lg:flex-col lg:h-full lg:min-h-[400px] pr-5 lg:pr-0">
				<div
					class="rounded-xl shrink-0 w-[342px] lg:w-auto h-[342px] lg:h-[146px] animate-pulse"
					:class="{
						'bg-blue-300/[0.075]': alternative,
						'bg-slate-300/[0.1]': !alternative
					}"
				></div>
				<div
					class="rounded-xl shrink-0 w-[342px] lg:w-auto h-[342px] lg:h-[146px] animate-pulse"
					:class="{
						'bg-blue-300/[0.075]': alternative,
						'bg-slate-300/[0.1]': !alternative
					}"
				></div>
				<div
					class="rounded-xl shrink-0 w-[342px] lg:w-auto h-[342px] lg:h-[146px] animate-pulse"
					:class="{
						'bg-blue-300/[0.075]': alternative,
						'bg-slate-300/[0.1]': !alternative
					}"
				></div>
			</div>
		</div>
		<div
			v-else
			class="flex lg:grid lg:grid-cols-3 gap-4 scrollbar-hide w-full"
		>
			<NuxtLink
				v-if="mainCard"
				class="news-card-primary lg:col-span-2 news-story-link"
				:style="
					alternative
						? `background: linear-gradient(135deg, #0057FF 0%, #DE59FF 100%)`
						: ''
				"
				:to="mainCard.slug"
			>
				<img
					v-if="mainCard.image"
					:src="`${hostname}cdn-cgi/image/quality=100,format=webp,width=700/${mainCard.image}`"
					alt="News Image"
					class="rounded-xl absolute inset-0 w-full h-full object-cover top-[1px] left-[1px] m-auto"
					:style="
						alternative
							? 'height: calc(100% - 3px); width: calc(100% - 3px); top: 1px; left: 1px;'
							: ''
					"
				/>
				<div
					class="absolute inset-0 bg-gradient-to-t from-[#1E3A8A] via-[#1E3A8A99] to-transparent rounded-xl pointer-events-none"
					style="z-index: 1"
					:style="
						alternative
							? 'height: calc(100% - 2px); width: calc(100% - 2px); top: 0; left: 0; right: 0; bottom: 0; margin: auto;'
							: ''
					"
				></div>
				<div class="card-body">
					<h2
						class="text-xl lg:text-3xl font-bold text-white lg:mb-3 mb-2 drop-shadow leading-tight"
						v-html="mainCard.title"
					></h2>

					<div class="text-base text-white/80 lg:mb-4">
						<RelativeTime :date="mainCard.date" />
					</div>
					<ClientOnly>
						<div
							v-if="
								mainCard.stock_pairs &&
								mainCard.stock_pairs[1] &&
								stocksStore.getStockSubscription(mainCard.stock_pairs[1])
							"
							class="lg:flex gap-3 hidden"
						>
							<TickerBadge
								:symbol="
									stocksStore.getStockSubscription(mainCard.stock_pairs[1])?.SYMBOL
								"
								:change="
									String(
										stocksStore
											.getStockSubscription(mainCard.stock_pairs[1])
											?.PC_CHG?.toFixed(2) || '0'
									) + '%'
								"
								appearence="clear"
							/>
						</div>
					</ClientOnly>
				</div>
			</NuxtLink>
			<div class="flex gap-4 lg:flex-col pr-5 lg:pr-0 lg:max-w-[300px]">
				<NuxtLink
					v-for="(card, idx) in sideCards"
					:key="card.slug || idx"
					:to="card.slug"
					class="news-card-secondary !lg:h-[144px] news-story-link"
					:class="{
						'lg:max-h-[154px]': idx > 0 && !alternative,
						'': idx === 0 && !alternative
					}"
				>
					<img
						:src="`${hostname}cdn-cgi/image/quality=100,format=webp,width=700/${card.image}`"
						alt="News Image"
						:style="
							alternative
								? 'height: calc(100% - 2px); width: calc(100% - 2px); top: 0; left: 0;'
								: ''
						"
						class="rounded-xl absolute inset-0 w-full h-full object-cover m-auto"
					/>
					<span
						v-if="alternative && idx !== 0"
						:style="
							alternative
								? 'height: calc(100% - 2px); width: calc(100% - 2px); top: 0; left: 0; background: linear-gradient(110.32deg, #091D56 8.05%, #331290 77.58%);'
								: ''
						"
						class="rounded-xl absolute inset-0 w-full h-full top-0 left-0 right-0 bottom-0 m-auto hidden lg:block"
					></span>

					<div
						class="relative p-4"
						:style="{
							zIndex: 10
						}"
					>
						<h2
							class="font-semibold text-white text-xl lg:text-lg mb-2 lg:mb-1 drop-shadow line-clamp-2 leading-normal"
							v-html="card.title"
						></h2>
						<div class="text-xs text-white/80 lg:mb-2">
							<RelativeTime :date="card.date" />
						</div>
						<ClientOnly>
							<div
								v-if="
									card.stock_pairs &&
									card.stock_pairs[1] &&
									stocksStore.getStockSubscription(card.stock_pairs[1])
								"
								class="lg:flex gap-2 hidden"
							>
								<TickerBadge
									:symbol="stocksStore.getStockSubscription(card.stock_pairs[1])?.SYMBOL"
									:change="
										String(
											stocksStore
												.getStockSubscription(card.stock_pairs[1])
												?.PC_CHG?.toFixed(2) || '0'
										) + '%'
									"
									appearence="clear"
								/>
							</div>
						</ClientOnly>
					</div>

					<div
						class="rounded-xl absolute inset-0 bg-gradient-to-t from-[#1E3A8A] via-[#1E3A8A99] to-transparent pointer-events-none"
						style="z-index: 1"
						:style="
							alternative
								? 'height: calc(100% - 2px); width: calc(100% - 2px); top: 0; left: 0; right: 0; bottom: 0; margin: auto;'
								: ''
						"
					></div>
				</NuxtLink>
			</div>
		</div>
	</section>
</template>
<script setup lang="ts">
import { computed, defineProps, onMounted, nextTick, watchEffect } from "vue";
import { useStocksStore } from "~/stores/useStocksStore";

const stocksStore = useStocksStore();

// Mobile text rendering optimization
onMounted(() => {
	if (process.client && window.innerWidth <= 1024) {
		nextTick(() => {
			// Force immediate text rendering on mobile
			const forceTextRender = () => {
				const textElements = document.querySelectorAll(
					"h2, .text-xl, .text-3xl, .text-base, .text-xs"
				);
				textElements.forEach((el: Element) => {
					const htmlEl = el as HTMLElement;
					htmlEl.style.transform = "translateZ(0)";
					htmlEl.style.opacity = "1";
					htmlEl.style.visibility = "visible";
					// Trigger reflow by accessing layout property
					void htmlEl.offsetHeight;
				});
			};

			// Force render immediately
			forceTextRender();

			// Add touch event listeners to force rendering on interaction
			const container = document.querySelector(".markets-hero-banner");
			if (container) {
				const handleTouch = () => {
					forceTextRender();
					// Force repaint of the entire container
					void (container as HTMLElement).offsetHeight;
				};

				container.addEventListener("touchstart", handleTouch, { passive: true });
				container.addEventListener("touchmove", handleTouch, { passive: true });
				container.addEventListener("scroll", handleTouch, { passive: true });
			}

			// Additional fallback - force render after a small delay
			setTimeout(forceTextRender, 50);
			setTimeout(forceTextRender, 200);
		});
	}
});

interface NewsItem {
	content_read_time: number;
	date: string;
	image: string;
	slug: string;
	stock: string;
	title: string;
	stock_pairs: string[];
}

const props = defineProps<{ news_list: NewsItem[]; alternative?: boolean }>();

const mainCard = computed(() => props.news_list?.[0]);
const sideCards = computed(() => props.news_list?.slice(1, 4));

// Extract stock symbols from news items and trigger data fetching
const stockSymbols = computed(() => {
	if (!props.news_list) {
		return [];
	}
	return props.news_list
		.filter((item) => item.stock_pairs && item.stock_pairs[1])
		.map((item) => item.stock_pairs[1])
		.filter(Boolean);
});

// Watch for stock symbols and update subscribed symbols. Adding to the
// subscribed set triggers the store's debounced quote fetching.
watchEffect(() => {
	if (stockSymbols.value.length > 0) {
		stockSymbols.value.forEach((symbol) => {
			stocksStore.stock_subscribed_symbols.add(symbol);
		});
	}
});

const {
	public: { hostname }
} = useRuntimeConfig();
</script>

<style scoped lang="scss">
@use "~/assets/utils.scss" as *;

/* Mobile text rendering fixes */
* {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-rendering: optimizeSpeed;
}

h2,
.text-xl,
.text-3xl,
.text-base,
.text-xs {
	/* Force hardware acceleration and proper rendering */
	transform: translateZ(0);
	will-change: transform;
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;

	/* Ensure text is always visible */
	opacity: 1 !important;
	visibility: visible !important;

	/* Mobile-specific font rendering */
	@media screen and (max-width: 1024px) {
		text-rendering: optimizeSpeed;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-feature-settings: "kern" 1;
		font-kerning: normal;
	}
}

.news-card-primary {
	position: relative;
	border-radius: 0.75rem;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	height: 342px;
	scroll-snap-align: center;
	flex-shrink: 0;
	min-width: 342px;
	max-width: 342px;

	@include breakpoint(lg) {
		grid-column: span 2 / span 2;

		height: 100%;
		min-height: 472px;
		width: 100%;
		max-width: 616px;
	}
}

.news-card-secondary {
	position: relative;
	border-radius: 0.75rem;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	height: 342px;
	scroll-snap-align: center;
	flex-shrink: 0;

	@include max-breakpoint(lg) {
		min-width: 342px;
		max-width: 342px;
	}
	/* Mobile rendering optimization */
	transform: translateZ(0);
	will-change: transform;

	@include breakpoint(lg) {
		// min-width: 0;
		// max-width: none;
		flex: 1;
		height: 144px;
	}
}

.hide-scrollbar {
	-ms-overflow-style: none;
	scrollbar-width: none;
	&::-webkit-scrollbar {
		display: none;
	}
}

.markets-hero-banner {
	width: 100vw;
	overflow-x: auto;
	scroll-snap-type: x mandatory;
	scroll-snap-align: start;
	scroll-snap-stop: always;
	left: -16px;
	position: relative;
	padding-left: 16px;
	scroll-behavior: smooth;

	/* Safari-compatible scrollbar hiding */
	scrollbar-width: none; /* Firefox */
	-ms-overflow-style: none; /* IE and Edge */
	&::-webkit-scrollbar {
		display: none; /* Safari and Chrome */
		width: 0;
		height: 0;
	}

	/* Safari-specific smooth scrolling */
	-webkit-overflow-scrolling: touch;

	@include breakpoint(lg) {
		overflow: hidden;
		width: 100%;
		left: 0;
		padding-left: 0;
		scroll-snap-type: none;
	}
}

.card-body {
	position: relative;
	z-index: 2;
	padding: 16px;

	/* Force proper rendering of text content */
	transform: translateZ(0);
	will-change: transform;

	/* Ensure text renders immediately */
	h2,
	p,
	div {
		opacity: 1;
		visibility: visible;
		font-display: swap;
	}

	@include breakpoint(lg) {
		padding: 16px 24px;
	}
}
</style>
